/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "Constants";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getMasterValues: () => {
    return axios.get(API_ENDPOINTS.GET_SITE_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug":"default"
      },
    });
  },
  sitelogoupload: (data) => {
      //console.log("userId:", userID);
      //console.log("image:", image);
      return axios.put(API_ENDPOINTS.SITE_IMAGE_UPLOAD+'/',data, {
        headers: {
          isAuthRequired: true,
          "Content-Type": "multipart/form-data",
        },
      });
    },
  updateMasterValues: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SITE_SETTINGS, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json" },
    });
  },
  getProfileDetails: (data) => {
    return axios.post(API_ENDPOINTS.PROFILE, data, {
      headers: { 
        isAuthRequired: true, 
        "Content-Type": "application/json",
        "x-tenant-slug":"default"
       },
    });
  },
  updateProfileDetails: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PROFILE+'/'+data.userID, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
  updatePassword: (data) => {
    //console.log('data-->',data.userID);
    return axios.put(API_ENDPOINTS.UPDATE_PASSWORD+'/'+data.userID, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  updateAppState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_APP_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },
  updateSmsState: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_SMS_STATE, data, {
      headers: { isAuthRequired: true, "Content-Type": "application/json","x-tenant-slug":"default" },
    });
  },

  //

  getPaymentSettings: () => {
    return axios.get(API_ENDPOINTS.GET_PAYMENT_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updatePaymentSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PAYMENT_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getPlatformSettings: () => {
    return axios.get(API_ENDPOINTS.GET_PLATFORM_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updatePlatformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PLATFORM_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getuserRewardformSettings: () => {
    return axios.get(API_ENDPOINTS.GET_USER_REWARD_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateuserRewardformSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_USER_REWARD_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getBusinessSettings: () => {
    return axios.get(API_ENDPOINTS.GET_BUSINESS_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateBusinessSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_BUSINESS_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getUserDetails: () => {
    return axios.get(API_ENDPOINTS.GET_USER_DETAILS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  changeUserPassword: (id, data) => {
    const url = `${API_ENDPOINTS.UPDATE_USER_PASSWORD}/${id}`;
    return axios.put(url, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getLegalSettings: () => {
    return axios.get(API_ENDPOINTS.GET_LEGAL_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateLegalSettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_LEGAL_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  getprivacySettings: () => {
    return axios.get(API_ENDPOINTS.GET_PRIVACY_SETTINGS, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },

  updateprivacySettings: (data) => {
    return axios.put(API_ENDPOINTS.UPDATE_PRIVACY_SETTINGS, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json","x-tenant-slug":"default"
      },
    });
  },
};
